document.addEventListener('DOMContentLoaded', () => { 
  const header = document.querySelector('.maviva-site-header');
  if (!header) return;

  const spacer = document.createElement('div');
  spacer.id = "MavivaHeaderSpacer";
  spacer.style.height = header.offsetHeight + 'px';
  header.parentNode.insertBefore(spacer, header);

  window.addEventListener('resize', () => {
    spacer.style.height = header.offsetHeight + 'px';
  });

  const searchTrigger = header.querySelector('.js-search-trigger');
  const searchInput = header.querySelector('.js-search-input');
  const searchClose = header.querySelector('.js-search-close');
  const searchResultsWrap = header.querySelector('.js-search-wrapper');
  const searchResults = header.querySelector('.js-search-results');
  const searchAllBtn = header.querySelector('.js-search-all');

  if (searchTrigger) {
    searchTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      header.classList.add('is-searching');
      setTimeout(() => {
        if (searchInput) searchInput.focus();
      }, 100);
    });
  }

  if (searchClose) {
    searchClose.addEventListener('click', () => {
      header.classList.remove('is-searching');
      if (searchInput) searchInput.value = '';
      if (searchResultsWrap) searchResultsWrap.classList.remove('has-results');
    });
  }

  let searchTimeout;
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      const query = this.value.trim();

      if (query.length < 2) {
        if (searchResultsWrap) searchResultsWrap.classList.remove('has-results');
        return;
      }

      searchTimeout = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`)
          .then(response => response.json())
          .then(data => {
            const products = data.resources.results.products;

            if (products.length > 0) {
              searchResults.innerHTML = products.map(product => `
                <a href="${product.url}" class="search-result-item">
                  <img src="${product.image || ''}" class="search-result-img" alt="">
                  <div class="search-result-info">
                    <span class="search-result-title">${product.title}</span>
                    <span class="search-result-price">${product.price}</span>
                  </div>
                </a>
              `).join('');

              searchAllBtn.href = `/search?q=${encodeURIComponent(query)}&type=product`;
              searchAllBtn.style.display = 'block';
              searchResultsWrap.classList.add('has-results');
            } else {
              searchResults.innerHTML = '<div style="padding:15px; font-size:14px; text-align:center; opacity:.6; grid-column:1 / -1;">Nessun prodotto trovato. Riprova con un altro termine.</div>';
              searchAllBtn.style.display = 'none';
              searchResultsWrap.classList.add('has-results');
            }
          })
          .catch(() => {
            searchResults.innerHTML = '<div style="padding:15px; font-size:14px; text-align:center; opacity:.6; grid-column:1 / -1;">Errore nel caricamento risultati.</div>';
            searchAllBtn.style.display = 'none';
            searchResultsWrap.classList.add('has-results');
          });
      }, 300);
    });
  }

  const popupToggles = header.querySelectorAll('.popup-toggle');
  const popupWrappers = header.querySelectorAll('.popup-wrapper');

  popupToggles.forEach((toggle) => {
    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      const wrapper = this.closest('.popup-wrapper');
      const isOpen = wrapper.classList.contains('is-open');

      popupWrappers.forEach((item) => item.classList.remove('is-open'));
      popupToggles.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));

      if (!isOpen) {
        wrapper.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function() {
    popupWrappers.forEach((item) => item.classList.remove('is-open'));
    popupToggles.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
  });

  const mobileNav = header.querySelector('.maviva-nav-mobile');
  const mobileOverlay = header.querySelector('.maviva-mobile-overlay');
  const openBtn = header.querySelector('.maviva-hamburger');
  const closeBtn = header.querySelector('.maviva-mobile-close');
  const level1 = header.querySelector('[id^="Mobile-Level1"]');
  const mobileGroups = header.querySelectorAll('.maviva-mobile-group');
  const mobileTriggers = header.querySelectorAll('.mobile-trigger');
  const backButtons = header.querySelectorAll('.mobile-back');

  function openMobileMenu() {
    if (!mobileNav || !mobileOverlay || !openBtn) return;
    mobileNav.classList.add('is-open');
    mobileOverlay.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileNav || !mobileOverlay || !openBtn) return;
    mobileNav.classList.remove('is-open');
    mobileOverlay.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    mobileGroups.forEach(group => group.classList.remove('is-active'));
    if (level1) level1.classList.add('is-active');
  }

  if (openBtn) openBtn.addEventListener('click', openMobileMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  mobileTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      if (!targetId) return;
      const target = header.querySelector('#' + CSS.escape(targetId));
      if (!target) return;

      mobileGroups.forEach(group => group.classList.remove('is-active'));
      target.classList.add('is-active');
    });
  });

  backButtons.forEach((btn) => {
    btn.addEventListener('click', function() {
      mobileGroups.forEach(group => group.classList.remove('is-active'));
      if (level1) level1.classList.add('is-active');
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      if (header.classList.contains('is-searching')) {
        header.classList.remove('is-searching');
        if (searchInput) searchInput.value = '';
        if (searchResultsWrap) searchResultsWrap.classList.remove('has-results');
      }
      popupWrappers.forEach((item) => item.classList.remove('is-open'));
      popupToggles.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    }
  });

  window.addEventListener('scroll', () => {
    if (window.scrollY > 20) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }, { passive: true });
});